import { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/Reveal";

const CONCEPTOS = ["Mojama", "Hueva de mújol", "Maruca", "Bonito"];

export default function Compare() {
  const reduce = useReducedMotion();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["end 0.55", "end 0.05"],
  });
  const opacity = useTransform(scrollYProgress, [0, 1], [1, 0.25]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 0.985]);

  return (
    <motion.div
      ref={ref}
      data-testid="salazones-comparacion"
      style={reduce ? undefined : { opacity, scale }}
      className="mt-14 grid origin-center border border-mirian-wine/20 md:grid-cols-2"
    >
      <div className="p-8 md:p-12">
        <Reveal>
          <p className="text-xs font-medium uppercase tracking-[0.26em] text-mirian-wine/55">
            Quien ya conoce la categoría
          </p>
        </Reveal>
        <ul className="mt-8">
          {CONCEPTOS.map((c, i) => (
            <Reveal key={c} delay={0.15 + i * 0.14} y={14}>
              <li
                data-testid={`compare-habitual-${i + 1}`}
                className="flex items-baseline justify-between gap-4 border-t border-mirian-wine/15 py-5"
              >
                <span className="font-serif text-2xl sm:text-3xl">{c}</span>
                <span className="text-right text-xs uppercase tracking-[0.16em] text-mirian-wine/55">
                  → tiene una referencia
                </span>
              </li>
            </Reveal>
          ))}
        </ul>
        <Reveal delay={0.85}>
          <p className="mt-8 text-xs uppercase tracking-[0.22em] text-mirian-wine/60">
            Conozco → Comparo → Elijo
          </p>
        </Reveal>
      </div>

      <div className="bg-mirian-wine p-8 text-mirian-cream md:p-12">
        <Reveal delay={0.9}>
          <p className="text-xs font-medium uppercase tracking-[0.26em] text-mirian-cream/55">
            Quien entra por primera vez
          </p>
        </Reveal>
        <ul className="mt-8">
          {CONCEPTOS.map((c, i) => (
            <Reveal key={c} delay={1.05 + i * 0.14} y={14}>
              <li
                data-testid={`compare-nuevo-${i + 1}`}
                className="flex items-baseline justify-between gap-4 border-t border-mirian-cream/15 py-5"
              >
                <span className="font-serif text-2xl sm:text-3xl">{c}</span>
                <span className="font-serif text-2xl italic text-mirian-cream/40">?</span>
              </li>
            </Reveal>
          ))}
        </ul>
      </div>
    </motion.div>
  );
}
